async function getData(api) {
	try {
		const response = await fetch(api);
		const data = await response.json();
		return data;
	} catch (error) {
		console.error("Error fetching data:", error);
		return [];
	}
}

export async function fetchCompanyInfo(symbol) {
	const info = await getData(
		`https://financialmodelingprep.com/api/v3/profile/${symbol}?apikey=0OlXvaWXwLdmZ7CM5vXed2rGuuyn17gy`
	);

	return info;
}
